<script>
import LetalaVnos from "./Letala_vnos.vue";
import DropDown from '../reUse/DropDown.vue';
import Notification from "../reUse/Notification.vue";
import {i18n} from '@/i18n'
import {config} from '@/config'
import sl from '@/Prevodi/Sifranti_Letala-sl.json';
import en from '@/Prevodi/Sifranti_Letala-en.json';
import it from '@/Prevodi/Sifranti_Letala-it.json';

export default {
  components: {
    'LetalaVnos': LetalaVnos,
    DropDown,
    Notification
  },
  props: {},
  emits: ['odjava'],
  data() {
    return {
      prikaz: 'vnosi',
      letala: [],
      izbranoLetalo: [],
      urejanje: false,
      urejanjeServis: false,
      idUrejanja: '',
      idIzbrisa: '',
      indexBrisanja: '',
      klubi: [],
      dKlub: false,
      dVrsta: false,
      uVlecno: '',
      uTip: '',
      uModel: '',
      uSerijska: '',
      uKlub: '',
      uSt_ur: '',
      uSt_letov: 0,
      uVrsta_letala: '',
      uDatum_nakupa: '',
      uDatum_registracije: '',
      uObracun_stevec: false,
      uRazpolozljivost: false,
      uCamo: false,
      uCamoFlight: false,
      uOpomba: '',
      uMasa: '',
      urejam: false,
      brisem: false,
      vrsta_letala: [
        {id: 0, vrsta: 'Jadralno'},
        {id: 1, vrsta: 'Motorno'},
        {id: 2, vrsta: 'Vitla'},
        {id: 3, vrsta: 'Ultralight'},
      ],
      //servisni podatki
      interval: '',
      zadnji_servis: '',
      servis_opravljen: '',
      naslednji_servis: '',
      komponente: [],
      //wb podatki
      urejanjeWb: false,
      cg_limit_min: '',
      cg_limit_max: '',
      max_masa: '',
      arm_gorivo: '',
      arm_masa: '',
      arm_prednji_sedez: '',
      arm_zadnji_sedez: '',
      arm_prtljaga: '',
      enotaMere: 'kg',
      max_gorivo: '',
      max_prtljaga: '',
      uZadnjiArm: false,
      plovnost: false,
      plovnost_opomba: '',
      //obvestila
      text: '',
      types: '',
      ShowNoti: false,
      modalPrikaz: 'pregled',
      searchLetala: '',
      searchType: 'registracija',
      pot: config.baseUrl,
      wgt_1: '',
      wgt_2: '',
      wgt_3x: '',
      wgt_3y: '',
      wgt_4: '',
      wgt_5: '',
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
  },
  mounted() {
    this.Read();
    this.ReadKlubi();
  },
  computed: {
    FilterLetal() {
      if (this.searchLetala !== '') {
        if (this.searchType === 'tip') {
          return this.letala.filter(letalo => letalo.tip.toLowerCase().includes(this.searchLetala.toLowerCase()));
        } else if (this.searchType === 'registracija') {
          return this.letala.filter(letalo => letalo.registracija.toLowerCase().includes(this.searchLetala.toLowerCase()));
        } else if (this.searchType === 'vrsta') {
          return this.letala.filter(letalo => letalo.vrsta_letala.toLowerCase().includes(this.searchLetala.toLowerCase()));
        } else {
          return this.letala.filter(letalo => letalo.klub.toLowerCase().includes(this.searchLetala.toLowerCase()));
        }
      }
      return this.letala;
    }
  },
  methods: {
    Read() {
      axios
          .get("./api/sifranti/letala/izpis/")
          .then((response) => {
            this.letala = response.data.letala;
          })
          .catch(function (napaka) {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri branju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    ReadKlubi() {
      axios.get('./api/sifranti/klubi/izpis/').then((response) => {
        this.klubi = response.data.klubi;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri branju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    Details(id) {
      this.izbranoLetalo = this.letala.filter(letalo => letalo.id === id);
      this.enotaMere = this.izbranoLetalo[0].enota_mase;
      $(this.$refs.modalKarticaLetala).modal('show');
    },
    DetailsOff() {
      $(this.$refs.modalKarticaLetala).modal('hide');
      //ponastavitev podatkov
      this.uVlecno = '';
      this.uTip = '';
      this.uModel = '';
      this.uSerijska = '';
      this.uKlub = '';
      this.uSt_ur = '';
      this.uSt_letov = 0;
      this.uVrsta_letala = '';
      this.uDatum_nakupa = '';
      this.uDatum_registracije = '';
      this.uOpomba = '';
      this.uCamo = false;
      this.uCamoFlight = false;
      this.uMasa = '';
      this.urejanje = false;
      this.izbranoLetalo = [];
    },
    potrdiIzbris(id) {
      this.idIzbrisa = id;
      this.text = 'Ali res želite pobrisati zapis?';
      this.types = "Vprašanje";
      this.ShowNoti = true;
    },
    izbrisiZapis() {
      this.brisem = true;
      if (this.idIzbrisa !== '') {
        let izbris = new URLSearchParams();
        izbris.append("id_brisanja", this.idIzbrisa);
        axios
            .post("./api/sifranti/letala/brisi/", izbris)
            .then((response) => {
              // $(this.$refs.modalObracunMotZapisa).modal('hide');
              this.Read();
              this.DetailsOff();
              // alert(text);
              this.text = "Zapis uspešno pobrisan";
              this.types = "Uspešno";
              this.ShowNoti = true;
              this.idIzbrisa = '';
              this.brisem = false;
            })
            .catch((napaka) => {
              this.brisem = false;
              if (napaka.response.status === 401) {
                this.$router.push('/Logout');
              }
              if (napaka.response.data.napaka !== undefined) {
                this.text = 'Napaka pri brisanju podatkov. ' + napaka.response.data.napaka;
              } else {
                this.text = 'Napaka pri brisanju podatkov.';
              }
              this.types = 'Napaka';
              this.ShowNoti = true;
            });
      } else if (this.indexBrisanja !== '') {
        this.komponente.splice(this.indexBrisanja, 1);
        this.ShowNoti = false;
      }
    },
    UrediZapis(id) {
      this.idUrejanja = id;
      this.urejanje = true;
      this.uVlecno = this.izbranoLetalo[0].vlecno;
      this.uTip = this.izbranoLetalo[0].tip;
      this.uModel = this.izbranoLetalo[0].model;
      this.uSerijska = this.izbranoLetalo[0].serijska;
      this.uKlub = this.izbranoLetalo[0].klub;
      this.uSt_ur = this.izbranoLetalo[0].st_ur;
      this.uSt_letov = this.izbranoLetalo[0].st_letov;
      this.uVrsta_letala = this.izbranoLetalo[0].vrsta_letala;
      this.uDatum_nakupa = this.izbranoLetalo[0].datum_nakupa;
      this.uDatum_registracije = this.izbranoLetalo[0].datum_registracije;
      this.uOpomba = this.izbranoLetalo[0].opomba;
      this.uFlight_time = this.izbranoLetalo[0].flight_time;
      this.uRazpolozljivost = this.izbranoLetalo[0].razpolozljivost;
      this.uCamo = this.izbranoLetalo[0].camo_pregled;
      this.uCamoFlight = this.izbranoLetalo[0].camo_flight;
      this.enotaMere = this.izbranoLetalo[0].enota_mase;
      this.uZadnjiArm = this.izbranoLetalo[0].ima_zadnji_sedez;
      this.wgt_1 = this.izbranoLetalo[0].wgt_1;
      this.wgt_2 = this.izbranoLetalo[0].wgt_2;
      this.wgt_3x = this.izbranoLetalo[0].wgt_3x;
      this.wgt_3y = this.izbranoLetalo[0].wgt_3y;
      this.wgt_4 = this.izbranoLetalo[0].wgt_4;
      this.wgt_5 = this.izbranoLetalo[0].wgt_5;
    },
    UrediServis(id) {
      this.idUrejanja = id;
      this.urejanjeServis = true;
      this.interval = this.izbranoLetalo[0].servisni_interval;
      this.zadnji_servis = this.izbranoLetalo[0].zadnji_servis;
      this.servis_opravljen = this.izbranoLetalo[0].servis_opravljen;
      this.naslednji_servis = this.izbranoLetalo[0].datum_servisa;
      this.plovnost = this.izbranoLetalo[0].plovnost;
      this.plovnost_opomba = this.izbranoLetalo[0].plovnost_opomba !== null ? this.izbranoLetalo[0].plovnost_opomba : '';
    },
    UrediWB(id) {
      this.idUrejanja = id;
      this.urejanjeWb = true;
      this.cg_limit_min = this.izbranoLetalo[0].cg_limit_min;
      this.cg_limit_max = this.izbranoLetalo[0].cg_limit_max;
      this.max_masa = this.izbranoLetalo[0].max_masa;
      this.arm_gorivo = this.izbranoLetalo[0].arm_gorivo;
      this.arm_masa = this.izbranoLetalo[0].arm_masa;
      this.arm_prednji_sedez = this.izbranoLetalo[0].arm_prednji_sedez;
      this.arm_zadnji_sedez = this.izbranoLetalo[0].arm_zadnji_sedez;
      this.arm_prtljaga = this.izbranoLetalo[0].arm_prtljaga;
      this.uMasa = this.izbranoLetalo[0].masa_plovila;
      this.enotaMere = this.izbranoLetalo[0].enota_mase;
      this.max_gorivo = this.izbranoLetalo[0].max_gorivo;
      this.max_prtljaga = this.izbranoLetalo[0].max_prtljaga;
      this.uZadnjiArm = this.izbranoLetalo[0].ima_zadnji_sedez;
      this.wgt_1 = this.izbranoLetalo[0].wgt_1;
      this.wgt_2 = this.izbranoLetalo[0].wgt_2;
      this.wgt_3x = this.izbranoLetalo[0].wgt_3x;
      this.wgt_3y = this.izbranoLetalo[0].wgt_3y;
      this.wgt_4 = this.izbranoLetalo[0].wgt_4;
      this.wgt_5 = this.izbranoLetalo[0].wgt_5;
    },
    PosodobiZapis() {
      this.urejam = true;
      let podatki = new URLSearchParams();
      podatki.append('idU', this.idUrejanja);
      podatki.append('vlecno', this.uVlecno);
      podatki.append('tip', this.uTip);
      podatki.append('model', this.uModel);
      podatki.append('serijska', this.uSerijska);
      podatki.append('klub', this.uKlub);
      podatki.append('st_ur', (this.uSt_ur == null) ? '' : this.uSt_ur);
      podatki.append('st_letov', (this.uSt_letov === 0) ? '' : this.uSt_letov);
      podatki.append('vrsta_letala', this.uVrsta_letala);
      podatki.append('datum_nakupa', (this.uDatum_nakupa == null) ? '' : this.uDatum_nakupa);
      podatki.append('datum_registracije', (this.uDatum_registracije == null) ? '' : this.uDatum_registracije);
      podatki.append('flight_time', this.uFlight_time);
      podatki.append('razpolozljivost', this.uRazpolozljivost);
      podatki.append('camo_pregled', this.uCamo);
      if (this.uCamo) {
        podatki.append('camo_flight', this.uCamoFlight);
      }
      podatki.append('opomba', this.uOpomba);
      axios.post('./api/sifranti/letala/uredi/', podatki, {withCredentials: true}).then((response) => {
        this.urejam = false;
        this.izbranoLetalo[0].vlecno = this.uVlecno;
        this.izbranoLetalo[0].tip = this.uTip;
        this.izbranoLetalo[0].model = this.uModel;
        this.izbranoLetalo[0].serijska = this.uSerijska;
        this.izbranoLetalo[0].klub = this.uKlub;
        this.izbranoLetalo[0].st_ur = (this.uSt_ur === '') ? null : this.uSt_ur;
        this.izbranoLetalo[0].st_letov = (this.uSt_letov === 0) ? null : this.uSt_letov;
        this.izbranoLetalo[0].vrsta_letala = this.uVrsta_letala;
        this.izbranoLetalo[0].datum_nakupa = (this.uDatum_nakupa === '') ? null : this.uDatum_nakupa;
        this.izbranoLetalo[0].datum_registracije = (this.uDatum_registracije === '') ? null : this.uDatum_registracije;
        this.izbranoLetalo[0].opomba = this.uOpomba;
        this.izbranoLetalo[0].flight_time = this.uFlight_time;
        this.izbranoLetalo[0].razpolozljivost = this.uRazpolozljivost;
        this.izbranoLetalo[0].camo_pregled = this.uCamo;
        this.izbranoLetalo[0].camo_flight = this.uCamoFlight;
        this.Read(); //zaradi servisa podatke preberemo še 1x
        setTimeout(() => {
          this.Details(this.idUrejanja);
        }, 200);
        // this.UrediServis(this.idUrejanja);
        //ponastavitev podatkov
        this.uVlecno = '';
        this.uTip = '';
        this.uKlub = '';
        this.uSt_ur = '';
        this.uSt_letov = 0;
        this.uVrsta_letala = '';
        this.uDatum_nakupa = '';
        this.uDatum_registracije = '';
        this.uOpomba = '';
        this.urejanje = false;
        this.uFlight_time = false;
        this.uRazpolozljivost = false;
        this.uCamo = false;
        this.uCamoFlight = false;
        this.uMasa = '';
        // alert('podatki posodobljeni');
        this.text = 'podatki posodobljeni';
        this.types = "Uspešno";
        this.ShowNoti = true;

      }).catch((napaka) => {
        this.urejam = false;
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri posodbaljanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri posodbaljanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    PosodobiZapisServisa() {
      this.urejam = true;
      let podatki = new URLSearchParams();
      podatki.append('id_letala', this.idUrejanja);
      podatki.append('interval', this.interval);
      podatki.append('zadnji_servis', this.zadnji_servis);
      podatki.append('servis_opravljen', this.servis_opravljen);
      podatki.append('naslednji_servis', this.naslednji_servis);
      if (this.komponente.length > 0) {
        podatki.append('komponente', JSON.stringify(this.komponente));
      }
      if (!this.plovnost) {
        podatki.append('plovnost_opomba', this.plovnost_opomba);
      }
      podatki.append('plovnost', this.plovnost);
      axios.post('./api/sifranti/letala/vnos/servis/', podatki, {withCredentials: true}).then((response) => {
        this.urejam = false;
        this.izbranoLetalo[0].servisni_interval = this.interval;
        this.izbranoLetalo[0].zadnji_servis = this.zadnji_servis;
        this.izbranoLetalo[0].servis_opravljen = this.servis_opravljen;
        this.izbranoLetalo[0].datum_servisa = this.naslednji_servis;
        this.izbranoLetalo[0].plovnost = this.plovnost;
        this.izbranoLetalo[0].plovnost_opomba = this.plovnost_opomba;
        this.interval = '';
        this.zadnji_servis = '';
        this.servis_opravljen = '';
        this.naslednji_servis = '';
        this.text = 'podatki posodobljeni';
        this.types = "Uspešno";
        this.ShowNoti = true;
        this.urejanjeServis = false;
        this.plovnost = false;
        this.plovnost_opomba = '';
        this.Read(); //zaradi servisa podatke preberemo še 1x
        setTimeout(() => {
          this.Details(this.idUrejanja);
        }, 200);
      }).catch((napaka) => {
        this.urejam = false;
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri posodbaljanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri posodbaljanju podatkov.';
        }
      });
    },
    PosodobiZapisWB() {
      this.urejam = true;
      let podatki = new URLSearchParams();
      podatki.append('id_letala', this.idUrejanja);
      podatki.append('cg_limit_min', this.cg_limit_min);
      podatki.append('cg_limit_max', this.cg_limit_max);
      podatki.append('max_masa', this.max_masa);
      podatki.append('max_gorivo', this.max_gorivo);
      podatki.append('max_prtljaga', this.max_prtljaga);
      podatki.append('arm_gorivo', this.arm_gorivo);
      podatki.append('arm_masa', this.arm_masa);
      podatki.append('arm_prednji_sedez', this.arm_prednji_sedez);
      podatki.append('arm_zadnji_sedez', this.arm_zadnji_sedez);
      podatki.append('ima_arm_zadnji_sedez', this.uZadnjiArm);
      podatki.append('arm_prtljaga', this.arm_prtljaga);
      podatki.append('masa_plovila', this.uMasa);
      podatki.append('enota_mase', this.enotaMere);
      podatki.append('wgt_1', this.wgt_1);
      podatki.append('wgt_2', this.wgt_2);
      podatki.append('wgt_3x', this.wgt_3x);
      podatki.append('wgt_3y', this.wgt_3y);
      podatki.append('wgt_4', this.wgt_4);
      podatki.append('wgt_5', this.wgt_5);

      axios.post('./api/sifranti/letala/uredi/wb/', podatki, {withCredentials: true}).then((response) => {
        this.text = response.data.sporocilo;
        this.types = 'Uspešno';
        this.ShowNoti = true;
        this.izbranoLetalo[0].cg_limit_min = this.cg_limit_min;
        this.izbranoLetalo[0].cg_limit_max = this.cg_limit_max;
        this.izbranoLetalo[0].max_masa = this.max_masa;
        this.izbranoLetalo[0].arm_gorivo = this.arm_gorivo;
        this.izbranoLetalo[0].arm_masa = this.arm_masa;
        this.izbranoLetalo[0].arm_prednji_sedez = this.arm_prednji_sedez;
        this.izbranoLetalo[0].arm_zadnji_sedez = this.arm_zadnji_sedez;
        this.izbranoLetalo[0].arm_prtljaga = this.arm_prtljaga;
        this.izbranoLetalo[0].masa_plovila = this.uMasa;
        this.izbranoLetalo[0].enota_mase = this.enotaMere;
        this.izbranoLetalo[0].max_gorivo = this.max_gorivo;
        this.izbranoLetalo[0].max_prtljaga = this.max_prtljaga;
        this.izbranoLetalo[0].ima_zadnji_sedez = this.uZadnjiArm;
        this.izbranoLetalo[0].wgt_1 = this.wgt_1;
        this.izbranoLetalo[0].wgt_2 = this.wgt_2;
        this.izbranoLetalo[0].wgt_3x = this.wgt_3x;
        this.izbranoLetalo[0].wgt_3y = this.wgt_3y;
        this.izbranoLetalo[0].wgt_4 = this.wgt_4;
        this.izbranoLetalo[0].wgt_5 = this.wgt_5;
        this.cg_limit_min = '';
        this.cg_limit_max = '';
        this.max_masa = '';
        this.max_gorivo = '';
        this.max_prtljaga = '';
        this.arm_gorivo = '';
        this.arm_masa = '';
        this.arm_prednji_sedez = '';
        this.arm_zadnji_sedez = '';
        this.arm_prtljaga = '';
        this.urejam = false;
        this.urejanjeWb = false;
        this.uZadnjiArm = false;
        this.wgt_1 = '';
        this.wgt_2 = '';
        this.wgt_3x = '';
        this.wgt_3y = '';
        this.wgt_4 = '';
        this.wgt_5 = '';
      }).catch((napaka) => {
        this.urejam = false;
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri posodbaljanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri posodbaljanju podatkov.';
        }
      });
    },
    selectKlub(id) {
      let klub = this.klubi.find(vl => vl.id === id);
      if (klub) {
        this.dKlub = false;
        this.uKlub = klub.naziv;
      }
    },
    OpenKlub() {
      this.dKlub = !this.dKlub;
    },
    selectVrsta(id) {
      let vrsta = this.vrsta_letala.find(v => v.id === id);
      if (vrsta) {
        this.dVrsta = false;
        this.uVrsta_letala = vrsta.vrsta;
      }
    },
    OpenVrsta() {
      this.dVrsta = !this.dVrsta;
    },
    IzvozCSV() {
      var podatki = new URLSearchParams();
      podatki.append('sifrantL', JSON.stringify(this.letala));
      axios.post('./api/sifranti/csv/ ', podatki, {withCredentials: true}).then((response) => {
        window.open(this.pot + response.data.datoteka);
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    RazlikaDoServisa() {
      const letalo = this.izbranoLetalo?.[0];

      if (
          letalo?.zadnji_servis == null ||
          letalo?.servisni_interval == null ||
          !letalo?.ure_in_letenje
      ) {
        return 0;
      }

      const servis =
          Number(letalo.zadnji_servis) +
          Number(letalo.servisni_interval);

      const [ure, minute] = letalo.ure_in_letenje
          .split(':')
          .map(Number);

      const razlika = servis * 60 - (ure * 60 + minute);

      const absolutnaRazlika = Math.abs(razlika);
      const ureDoServisa = Math.floor(absolutnaRazlika / 60);
      const minuteDoServisa = absolutnaRazlika % 60;

      const predznak = razlika < 0 ? '-' : '';

      return `${predznak}${String(ureDoServisa).padStart(2, '0')}h:${String(minuteDoServisa).padStart(2, '0')}min`;
    },
    IzpisUrMin(cas) {
      let [ure, minute] = cas.split(':');

      return `${ure}h:${minute}min`;
    },
    DodajKomponento() {
      this.komponente.push({
        'id': '',
        'ime': '',
        'servis_interval': '',
        'zadnji_servis': '',
        'naslednji_servis': '',
        'servis_opravljen': '',
      });
    },
    OdstraniKomponento(index) {
      this.text = this.$t('obvestila.vprasanjeBrisa');
      this.types = 'Vprašanje';
      this.ShowNoti = true;
      this.indexBrisanja = index;
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{ $t('main.nazaj') }}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{ $t('main.title') }}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>

        <!-- Navigation Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">
            <button class="nav-tab" :class="{'active': prikaz === 'vnosi'}" @click="prikaz = 'vnosi'">
              <i class="fas fa-edit"></i>
              <span>{{ $t('navs.vnos') }}</span>
            </button>
            <button class="nav-tab" :class="{'active bg-rdeca': prikaz === 'branje'}" @click="prikaz = 'branje'">
              <i class="fas fa-list"></i>
              <span>{{ $t('navs.seznam') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <letala-vnos v-if="prikaz === 'vnosi'" @osvezi="Read()"/>
  <div v-else class='container p-4'>
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="izbrisiZapis" @ne="ShowNoti=false"
                    @closeNotification="ShowNoti = false"/>
    </Transition>
    <br>
    <div class="col-12 sticky bg-wingsi p-4">
      <div class="container">
        <div class="btn-group mb-2" role="group">
          <button
              type="button"
              class="btn"
              :class="searchType === 'registracija' ? 'btn-primary' : 'btn-outline-primary'"
              @click="searchType = 'registracija'"
          >
            Registracija
          </button>

          <button
              type="button"
              class="btn"
              :class="searchType === 'tip' ? 'btn-primary' : 'btn-outline-primary'"
              @click="searchType = 'tip'"
          >
            Tip
          </button>

          <button
              type="button"
              class="btn"
              :class="searchType === 'klub' ? 'btn-primary' : 'btn-outline-primary'"
              @click="searchType = 'klub'"
          >
            Klub
          </button>

          <button
              type="button"
              class="btn"
              :class="searchType === 'vrsta' ? 'btn-primary' : 'btn-outline-primary'"
              @click="searchType = 'vrsta'"
          >
            Vrsta
          </button>
        </div>

        <div class="position-relative">
          <input
              class="input border-0 rounded-4 p-2 pe-5 fs-5"
              type="text"
              :placeholder="searchType === 'tip'
          ? 'Išči po tipu'
          : searchType === 'klub'
            ? 'Išči po klubu' :
            searchType === 'registracija' ?
            'Išči po registraciji'
            : 'Išči po vrsti plovila'"
              v-model="searchLetala"
          />

          <i class="fas fa-search iskalnik"></i>
        </div>

      </div>
    </div>

    <div class="pregled-povrsin-container">
      <div class='section-content'>
        <h4 class="text-white">
          <button class='btn btn-sm btn-outline-warning' :disabled="!FilterLetal.length > 0" @click.prevent="IzvozCSV">
            {{ $t('buttons.csv') }} <i class="fas fa-file-csv"></i>
          </button>
        </h4>
        <!-- desktop -->
        <div class="desktop-grid">
          <div class="grid-container">
            <!-- Header row -->
            <div class="grid-header d-flex justify-content-between">
              <div class="grid-cell text-center">{{ $t('table.registracija') }}</div>
              <div class="grid-cell text-center">{{ $t('table.s_ure') }}</div>
              <div class="grid-cell text-center">{{ $t('table.s_letov') }}</div>
              <div class="grid-cell text-center">{{ $t('table.tip') }}</div>
              <div class="grid-cell text-center">{{ $t('table.vrsta') }}</div>
              <div class="grid-cell text-center">Klub</div>
              <div class="grid-cell text-center">{{ $t('table.podrobno') }}</div>
            </div>

            <!-- data row -->
            <div class="grid-row d-flex justify-content-between" v-for='letalo in FilterLetal'
                 @click.prevent='Details(letalo.id)'>
              <div class="grid-cell text-white text-center">{{ letalo.registracija }}</div>
              <div class="grid-cell text-white center">{{ letalo.ure_in_letenje }}</div>
              <div class="grid-cell text-white center">{{ letalo.s_st_letov }}</div>
              <div class="grid-cell text-white center">{{ letalo.tip }}</div>
              <div class="grid-cell text-white text-center">{{ letalo.vrsta_letala }}</div>
              <div class="grid-cell text-white text-center">{{ letalo.klub }}</div>
              <div class="grid-cell text-white text-center">
                <button type="button"
                        class="btn btn-primary mb-3"
                        @@click.prevent='Details(letalo.id)'>
                  <span><i class="far fa-id-card"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Mobile/Tablet Multi-Select View -->
        <div class="mobile-multiselect">
          <div class="remarks-item">
            <div class="area-selection">
              <div class='row mt-3' v-for='letalo in FilterLetal' @click.prevent='Details(letalo.id)'>
                <!--TEST PRIKAZ MOBILE-->
                <!-- LEVI STOLPEC -->
                <div class="col-6 d-flex flex-column">
                  <div class="text-white text-start">{{ $t('table.registracija') }}</div>
                  <div class="text-white text-start">{{ $t('table.s_ure') }}</div>
                  <div class="text-white text-start">{{ $t('table.s_letov') }}</div>
                  <div class="text-white text-start">{{ $t('table.tip') }}</div>
                  <div class="text-white text-start">Klub</div>
                  <div class="text-white text-start d-none d-md-block">
                    {{ $t('table.podrobno') }}
                  </div>
                </div>

                <!-- DESNI STOLPEC -->
                <div class="col-6 d-flex flex-column">
                  <div class="text-white text-end text-limit">{{ letalo.registracija }}</div>
                  <div class="text-white text-end text-limit">{{ letalo.ure_in_letenje }}</div>
                  <div class="text-white text-end text-limit">{{ letalo.s_st_letov }}</div>
                  <div class="text-white text-end text-limit">{{ letalo.tip }}</div>
                  <div class="text-white text-end text-limit">{{ letalo.klub }}</div>

                  <!-- Desktop gumb -->
                  <div class="text-center d-none d-md-block">
                    <button type="button" class="btn btn-primary w-100">
                      <i class="far fa-id-card"></i>
                    </button>
                  </div>
                </div>

                <!-- Mobile gumb -->
                <div class="col-12 d-md-none mt-2">
                  <button type="button" class="btn btn-primary w-100" @click.prevent='Details(letalo.id)'>
                    <i class="far fa-id-card"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- LETALA PODROBNO -->
  <div class="modal modal-kartica" ref="modalKarticaLetala" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content list-dark border-orange" v-if="izbranoLetalo.length > 0">
        <div class='d-flex justify-content-between'>
          <h5 class="card-title mb-2 mb-md-0 mt-3 ms-4">
            <i class="fas fa-plane fa-lg"></i>
            {{ izbranoLetalo[0].registracija }}
          </h5>
          <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOff">
            <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
          </button>
        </div>
        <!-- Navigation Tabs -->
        <div class="modal-header d-flex flex-wrap align-items-center justify-content-between">

          <div class="d-flex flex-wrap gap-2 justify-content-between w-100">
            <button
                class="nav-tab"
                :class="{'active': modalPrikaz === 'pregled'}"
                @click="modalPrikaz = 'pregled'">
              <i class="fas fa-edit"></i>
              <span>{{ $t('navs.modal.pregled') }}</span>
            </button>

            <button
                class="nav-tab"
                :class="{'active': modalPrikaz === 'servis'}"
                @click="modalPrikaz = 'servis'">
              <i class="fas fa-list"></i>
              <span>{{ $t('navs.modal.servisna') }}</span>
            </button>

            <button
                class="nav-tab"
                :class="{'active': modalPrikaz === 'wb'}"
                @click="modalPrikaz = 'wb'">
              <i class="fas fa-cog"></i>
              <span>{{ $t('navs.modal.wb') }}</span>
            </button>
          </div>

        </div>

        <div class='modal-header justify-content-between'>
          <h5 class='meni col-6' v-if="modalPrikaz === 'servis'"><i class="fas fa-tools"></i> Servisni podatki</h5>
          <h5 class='meni col-8' v-if="modalPrikaz === 'wb'"><i class="fas fa-cog"></i> W&B "Arm" nastavitve</h5>
          <div class="d-flex justify-content-between">
            <div class="badge-camo" v-if="modalPrikaz === 'servis'">
            <span>
              Stanje na {{ new Date().toLocaleDateString("sl-SL") }}
            </span>
              <br/>
              <span class="text-start mt-2">{{ new Date().toLocaleTimeString("sl-SL") }}</span>
            </div>
            <div class='text-end col-4 col-md-5' v-if="this.urejanjeServis">
              <button class="btn btn-outline-danger" v-if="this.urejanjeServis"
                      @click.prevent="this.urejanjeServis = false"><i class="fas fa-times"></i></button>
            </div>
          </div>
          <h5 class='meni col-8' v-if="modalPrikaz === 'pregled'"><i class="fas fa-file-alt"></i> Podatki letala</h5>
          <div class='text-end col-4' v-if="this.urejanje || this.urejanjeWb">
            <button class="btn btn-outline-danger" v-if="this.urejanje" @click.prevent="this.urejanje = false"><i
                class="fas fa-times"></i></button>
            <button class="btn btn-outline-danger" v-if="this.urejanjeWb" @click.prevent="this.urejanjeWb = false"><i
                class="fas fa-times"></i></button>
          </div>
          <hr/>
        </div>

        <!-- PREGLED PODAKTOV -->
        <div class="modal-body col-12" v-if="modalPrikaz === 'pregled'">
          <ul class='list-group list-group-flush' v-if="!this.urejanje">
            <!-- <li class='list-group-item'>registracija: {{izbranoLetalo[0].registracija}}</li> -->
            <li class='list-group-item list-dark'>{{ $t('modal.vlecno') }} <i class="fas"
                                                                              :class="{'fa-times text-danger': !izbranoLetalo[0].vlecno, 'fa-check text-success': izbranoLetalo[0].vlecno }"></i>
            </li>
            <li class='list-group-item list-dark'>{{ $t('modal.tip') }} <span
                class='text-lorange'> {{ izbranoLetalo[0].tip }}</span></li>
            <li class='list-group-item list-dark'>{{ $t('modal.model') }} <span
                class='text-lorange'> {{ izbranoLetalo[0].model }}</span></li>
            <li class='list-group-item list-dark'>{{ $t('modal.serijska') }} <span
                class='text-lorange'> {{ izbranoLetalo[0].serijska }}</span></li>
            <li class='list-group-item list-dark'>{{ $t('modal.klub') }} <span
                class='text-lorange'> {{ izbranoLetalo[0].klub }}</span></li>
            <li class='list-group-item list-dark'>{{ $t('modal.stUr') }} <span
                class='text-lorange'> {{ izbranoLetalo[0].st_ur }}</span></li>
            <li class='list-group-item list-dark'>{{ $t('modal.stLetov') }} <span
                class='text-lorange'> {{ izbranoLetalo[0].st_letov }}</span></li>
            <li class='list-group-item list-dark'>{{ $t('modal.vrsta') }} <span
                class='text-lorange'> {{ izbranoLetalo[0].vrsta_letala }}</span></li>
            <li class='list-group-item list-dark'>{{ $t('modal.datumN') }} <span
                class='text-lorange'> {{ izbranoLetalo[0].datum_nakupa.split('-').reverse().join('.') }}</span></li>
            <li class='list-group-item list-dark'>{{ $t('modal.datumR') }} <span
                class='text-lorange'> {{ izbranoLetalo[0].datum_registracije.split('-').reverse().join('.') }}</span>
            </li>
            <li class='list-group-item list-dark'>{{ $t('modal.obracun_servis') }} <i class="fas"
                                                                                      :class="{'fa-times text-danger': !izbranoLetalo[0].flight_time, 'fa-check text-success': izbranoLetalo[0].flight_time }"></i>
            </li>
            <li class='list-group-item list-dark'>{{ $t('modal.razpolozljivo') }} <i class="fas"
                                                                                     :class="{'fa-times text-danger': !izbranoLetalo[0].razpolozljivost, 'fa-check text-success': izbranoLetalo[0].razpolozljivost }"></i>
            </li>
            <li class='list-group-item list-dark'>{{ $t('modal.camo_pregled') }} <i class="fas"
                                                                                    :class="{'fa-times text-danger': !izbranoLetalo[0].camo_pregled, 'fa-check text-success': izbranoLetalo[0].camo_pregled }"></i>
            </li>
            <li class='list-group-item list-dark' v-if="izbranoLetalo[0].camo_pregled">{{ $t('modal.camo_flight') }} <i
                class="fas"
                :class="{'fa-times text-danger': !izbranoLetalo[0].camo_flight, 'fa-check text-success': izbranoLetalo[0].camo_flight }"></i>
            </li>
            <li class='list-group-item list-dark'>
              {{ (izbranoLetalo[0].vrsta_letala === 'Jadralno') ? $t('modal.opombaJ') : $t('modal.opomba') }} <span
                class='text-lorange'> {{ izbranoLetalo[0].opomba }}</span></li>
            <li class='list-group-item list-dark'>{{ $t('modal.datumV') }} <span
                class='text-lorange'>  {{ izbranoLetalo[0].datum_vnosa_sl }}</span></li>
          </ul>
          <!-- PREGLED UREJANJE -->
          <ul class='list-group list-group-flush' v-else>
            <!-- <li class='list-group-item'>registracija: {{izbranoLetalo[0].registracija}}</li> -->
            <li class='list-group-item list-dark'>{{ $t('labels.vlecno') }} <i class="fas text-orange"
                                                                               :class="{'fa-times text-danger': !izbranoLetalo[0].vlecno, 'fa-check text-success': izbranoLetalo[0].vlecno }"></i>
              <input class="input-radio" type="checkbox" id="instruktor" v-model="uVlecno"/></li>
            <li class='list-group-item list-dark'>{{ $t('labels.tip') }} <span
                class='text-lorange'>{{ izbranoLetalo[0].tip }}</span> <input class="input border-0 rounded-4 p-2 fs-5"
                                                                              type="text" id="uTip" v-model="uTip"
                                                                              required/></li>
            <li class='list-group-item list-dark'>{{ $t('labels.model') }} <span
                class='text-lorange'>{{ izbranoLetalo[0].model }}</span> <input
                class="input border-0 rounded-4 p-2 fs-5" type="text" id="uTip" v-model="uModel" required/></li>
            <li class='list-group-item list-dark'>{{ $t('labels.serijska') }} <span
                class='text-lorange'>{{ izbranoLetalo[0].serijska }}</span> <input
                class="input border-0 rounded-4 p-2 fs-5" type="text" id="uTip" v-model="uSerijska" required/></li>
            <li class='list-group-item list-dark'>{{ $t('modal.klub') }} <span
                class='text-lorange'>{{ izbranoLetalo[0].klub }}</span>
              <div class="container">
                <label class="label-dropdown" for="namen">{{ $t('labels.klub') }}
                  <button v-if="uKlub !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="uKlub = ''">
                    {{ $t('buttons.brisiIzbiro') }}
                  </button>
                </label>
                <div class="drop-down-icon text-black" @click.prevent="OpenKlub()">
                  <i v-show="!dKlub" class="fas fa-chevron-right"></i>
                  <i v-show="dKlub" class="fas fa-chevron-down"></i>
                </div>
                <button class="input border-0 rounded-4 p-2 fs-5" id="klub" @click.prevent="OpenKlub">
                  {{ uKlub }}
                </button>
                <transition name="fade">
                  <drop-down @klub="selectKlub" :data="klubi" type="klubi" class="drop-down-btn" v-if="dKlub"/>
                </transition>
              </div>
            </li>
            <li class='list-group-item list-dark' v-if="uSt_ur !== null">{{ $t('labels.stUr') }} <span
                class='text-lorange'>{{ izbranoLetalo[0].st_ur }}</span> <input
                class="input border-0 rounded-4 p-2 fs-5" type="text" id="uSt_ur" v-model="uSt_ur" required/></li>
            <li class='list-group-item list-dark' v-if="uSt_letov !== null">{{ $t('labels.stLetov') }} <span
                class='text-lorange'>{{ izbranoLetalo[0].st_letov }}</span> <input
                class="input border-0 rounded-4 p-2 fs-5" type="text" id="uSt_letov" v-model="uSt_letov" required/></li>
            <li class='list-group-item list-dark'>{{ $t('modal.vrsta') }} <span
                class='text-lorange'>{{ izbranoLetalo[0].vrsta_letala }}</span>
              <div class="container">
                <label class="label-dropdown" for="vrsta">{{ $t('labels.vrsta') }}
                  <button v-if="uVrsta_letala !== ''" class="btn btn-sm btn-outline-warning"
                          @click.prevent="uVrsta_letala = ''">{{ $t('buttons.brisiIzbiro') }}
                  </button>
                </label>
                <div class="drop-down-icon text-black" @click.prevent="OpenVrsta()">
                  <i v-show="!dVrsta" class="fas fa-chevron-right"></i>
                  <i v-show="dVrsta" class="fas fa-chevron-down"></i>
                </div>
                <button class="input border-0 rounded-4 p-2 fs-5" id="regLetala" @click.prevent="OpenVrsta">
                  {{ uVrsta_letala }}
                </button>
                <transition name="fade">
                  <drop-down @vrsta="selectVrsta" :data="vrsta_letala" type="vrsta" class="drop-down-btn"
                             v-if="dVrsta"/>
                </transition>
              </div>
            </li>
            <li class='list-group-item list-dark' v-if="uDatum_nakupa !== null">{{ $t('labels.datumN') }} <span
                class='text-lorange'>{{ izbranoLetalo[0].datum_nakupa }}</span> <input
                class="input border-0 rounded-4 p-2 fs-5" type="date" id="uDatum_nakupa" v-model="uDatum_nakupa"
                required/></li>
            <li class='list-group-item list-dark' v-if="uDatum_registracije !== null">{{ $t('labels.datumR') }} <span
                class='text-lorange'>{{ izbranoLetalo[0].datum_registracije }}</span> <input
                class="input border-0 rounded-4 p-2 fs-5" type="date" id="uDatum_registracije"
                v-model="uDatum_registracije" required/></li>
            <!-- OBRAČUN ŠTEVEC SWITCH -->
            <li class='list-group-item list-dark'>{{ $t('labels.obracunStevec') }} <i class="fas text-orange"
                                                                                      :class="{'fa-times text-danger': !izbranoLetalo[0].flight_time, 'fa-check text-success': izbranoLetalo[0].flight_time }"></i>
              <div class="col-12">
                <div class="container">
                  <div class="input border-0 rounded-4 p-2 fs-5">
                    <label class='switch col-6'>
                      <input type='checkbox' v-model="uFlight_time" :checked="uFlight_time">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </li>
            <!-- RAZPOLOŽLJIVOST SWITCH -->
            <li class='list-group-item list-dark'>{{ $t('labels.razpolozljivo') }} <i class="fas text-orange"
                                                                                      :class="{'fa-times text-danger': !izbranoLetalo[0].razpolozljivost, 'fa-check text-success': izbranoLetalo[0].razpolozljivost }"></i>
              <div class="col-12">
                <div class="container">
                  <div class="input border-0 rounded-4 p-2 fs-5">
                    <label class='switch col-6'>
                      <input type='checkbox' v-model="uRazpolozljivost" :checked="uRazpolozljivost">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </li>
            <!-- CAMO PREGLED SWITCH -->
            <li class='list-group-item list-dark'>{{ $t('labels.camo_pregled') }} <i class="fas text-orange"
                                                                                     :class="{'fa-times text-danger': !izbranoLetalo[0].camo_pregled, 'fa-check text-success': izbranoLetalo[0].camo_pregled }"></i>
              <div class="col-12">
                <div class="container">
                  <div class="input border-0 rounded-4 p-2 fs-5">
                    <label class='switch col-6'>
                      <input type='checkbox' v-model="uCamo" :checked="uCamo">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </li>
            <!-- CAMO FLIGHT ČAS -->
            <li class='list-group-item list-dark' v-if="uCamo">{{ $t('labels.camo_flight') }} <i class="fas text-orange"
                                                                                                 :class="{'fa-times text-danger': !izbranoLetalo[0].camo_flight, 'fa-check text-success': izbranoLetalo[0].camo_flight }"></i>
              <div class="col-12">
                <div class="container">
                  <div class="input border-0 rounded-4 p-2 fs-5">
                    <label class='switch col-6'>
                      <input type='checkbox' v-model="uCamoFlight" :checked="uCamoFlight">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </li>
            <li class='list-group-item list-dark'>
              {{ (izbranoLetalo[0].vrsta_letala === 'Jadralno') ? $t('labels.opombaJ') : $t('labels.opomba') }} <span
                class='text-lorange'>{{ izbranoLetalo[0].opomba }}</span> <input
                class="input border-0 rounded-4 p-2 fs-5" type="text" id="uOpomba" v-model="uOpomba" required/></li>
          </ul>
          <!-- /PREGLED UREJANJE -->
        </div>
        <div v-if="modalPrikaz === 'pregled'" class="modal-footer col-12">
          <!-- UREDI GUMB -->
          <button class="btn btn-outline-warning" v-if="!this.urejanje"
                  @click.prevent="UrediZapis(izbranoLetalo[0].id)">
            <i class="fas fa-user-edit"></i>{{ $t('buttons.uredi') }}
          </button>
          <!-- POSODOBI GUMB -->
          <button class="btn btn-outline-success" v-else @click.prevent="PosodobiZapis()" :disabled="urejam">
            <i class="fas fa-sync-alt"></i> <i class="fas fa-spinner fa-spin" v-if="urejam"></i>
            {{ $t('buttons.posodobi') }}
          </button>&nbsp;
          <!-- BRISI GUMB -->
          <button class="btn btn-outline-danger" v-if="!this.urejanje"
                  @click.prevent="potrdiIzbris(izbranoLetalo[0].id)" :disabled="brisem">
            <i class="fas fa-trash"></i> <i class="fas fa-spinner fa-spin" v-if="brisem"></i> {{ $t('buttons.brisi') }}
          </button>
        </div>
        <!-- /PREGLED -->
        <!-- SERVISNA KNJIGA -->
        <div class="modal-body col-12" v-if="modalPrikaz === 'servis'">
          <ul class='list-group list-group-flush' v-if="!this.urejanjeServis">
            <!--            <li class='list-group-item list-dark'>{{$t('modal.stLetov')}} <span class='text-lorange'>{{izbranoLetalo[0].st_letov}}</span></li>-->
            <li class='list-group-item list-dark'>{{ $t('modal.servis.stLetov') }} <span
                class='text-lorange'>{{ izbranoLetalo[0].s_st_letov }}</span></li>
            <!--            <li class='list-group-item list-dark'>{{$t('modal.stUr')}} <span class='text-lorange'>{{izbranoLetalo[0].st_ur}}</span></li>-->
            <li class='list-group-item list-dark'>{{ $t('modal.servis.stSUr') }} <span
                class='text-lorange'>{{ IzpisUrMin(izbranoLetalo[0].ure_in_letenje) }}</span></li>
            <li class='list-group-item list-dark'>{{ $t('modal.servis.doServisa') }} <span
                class='text-lorange'>{{ RazlikaDoServisa() }}</span></li>

            <li class='list-group-item list-dark'>{{ $t('modal.servis.interval') }} <span
                class='text-lorange'>{{
                izbranoLetalo[0].servisni_interval == null ? '/' : izbranoLetalo[0].servisni_interval
              }}h</span>
            </li>
            <li class='list-group-item list-dark'>{{ $t('modal.servis.datum_zServis') }} <span
                class='text-lorange'>{{
                izbranoLetalo[0].servis_opravljen == null ? '/' : izbranoLetalo[0].servis_opravljen.split('-').reverse().join('.')
              }}</span>
            </li>
            <li class='list-group-item list-dark'>{{ $t('modal.servis.opravljen_servis') }} <span class='text-lorange'>{{
                izbranoLetalo[0].zadnji_servis == null ? '/' : izbranoLetalo[0].zadnji_servis + 'h'
              }}</span>
            </li>
            <li class='list-group-item list-dark'>{{ $t('modal.servis.naslednji_servis') }} <span class='text-lorange'>{{
                izbranoLetalo[0].datum_servisa == null ? '/' : izbranoLetalo[0].datum_servisa.split('-').reverse().join('.')
              }}</span>
            </li>
            <li class='list-group-item list-dark'>{{ $t('modal.servis.status') }}
              <span class='service-status'
                    :class="{'status-ok': izbranoLetalo[0].plovnost, 'status-danger': !izbranoLetalo[0].plovnost}">
                <i class="fas fa-circle"
                   :class="{'text-success': izbranoLetalo[0].plovnost, 'text-danger': !izbranoLetalo[0].plovnost}"></i> {{
                  izbranoLetalo[0].plovnost ? 'Letalo plovno' : 'Letalo ni plovno'
                }}
              </span>
            </li>
            <li class='list-group-item list-dark' v-if="!izbranoLetalo[0].plovnost">
              {{ $t('modal.servis.plovnost_opomba') }}
              <span class='text-lorange'>
                {{ izbranoLetalo[0].plovnost_opomba }}
              </span>
            </li>
          </ul>
          <ul class='list-group list-group-flush' v-else>
            <li class='list-group-item list-dark'>{{ $t('modal.servis.interval') }} <span class='text-lorange'>{{
                izbranoLetalo[0].servisni_interval == null ? 'Še ni nastavljen' : izbranoLetalo[0].servisni_interval
              }}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="number" id="uOpomba" v-model="interval"
                               required/></li>
            <li class='list-group-item list-dark'>{{ $t('modal.servis.datum_zServis') }} <span
                class='text-lorange'>{{
                izbranoLetalo[0].servis_opravljen == null ? 'Še ni nastavljen' : izbranoLetalo[0].servis_opravljen.split('-').reverse().join('.')
              }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="uOpomba" v-model="servis_opravljen"
                     required/></li>
            <li class='list-group-item list-dark'>{{ $t('modal.servis.opravljen_servis') }} <span class='text-lorange'>{{
                izbranoLetalo[0].zadnji_servis == null ? 'Še ni nastavljen' : izbranoLetalo[0].zadnji_servis
              }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" id="uOpomba" v-model="zadnji_servis"
                     required/></li>
            <li class='list-group-item list-dark'>{{ $t('modal.servis.naslednji_servis') }} <span class='text-lorange'>{{
                izbranoLetalo[0].datum_servisa == null ? 'Še ni nastavljen' : izbranoLetalo[0].datum_servisa.split('-').reverse().join('.')
              }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="uOpomba" v-model="naslednji_servis"
                     required/></li>
            <!-- PLOVNOST SWITCH -->
            <li class='list-group-item list-dark'>{{ $t('modal.servis.plovnost') }}
              <i class="fas text-orange"
                 :class="{'fa-times text-danger': !izbranoLetalo[0].plovnost, 'fa-check text-success': izbranoLetalo[0].plovnost }"></i>
              <div class="col-12">
                <div class="container">
                  <div class="input border-0 rounded-4 p-2 fs-5">
                    <label class='switch col-6'>
                      <input type='checkbox' v-model="plovnost" :checked="plovnost">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item list-dark" v-if="!plovnost">
              {{ $t('modal.servis.plovnost_opomba') }}
              <span
                  class='text-lorange'>{{
                  izbranoLetalo[0].plovnost_opomba == null ? '/' : izbranoLetalo[0].plovnost_opomba
                }}</span><br/>
              <span
                  :class="{'text-success': plovnost_opomba.length <=45, 'text-danger': plovnost_opomba.length >=46}">({{
                  plovnost_opomba.length
                }}/50)</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="plovnost_opomba" maxlength="50"
                     placeholder="kratka opomba" v-model="plovnost_opomba"/>
            </li>
            <!-- KOMPONENTE  -->
            <!--            <div class="col-12">-->
            <!--              <div class="container p-2">-->
            <!--                <button class="btn btn-outline-success rounded" @click.prevent="DodajKomponento()">{{$t('buttons.dodajKomponento')}}</button>-->
            <!--              </div>-->
            <!--              <TransitionGroup name="fade">-->
            <!--                <div v-for="(komponenta, index) in komponente" class="container shadow p-2 rounded" :key="index">-->
            <!--                  <div :class="{ hidden: komponenta.ime.length > 0 }" class="label-time">Komponenta:{{index + 1}} - <button class="btn btn-outline-danger rounded btn-sm" @click.prevent="OdstraniKomponento(index)"><i  class="far fa-minus fa" ></i></button></div>-->
            <!--                  <label :class="{ hidden: komponenta.ime.length > 0 }" class="label-time p-2" for="komponenta-{{index}}-ime">{{$t('labels.komponenta.ime')}}</label>-->
            <!--                  <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="{{index}}" v-model="komponenta.ime" required />-->
            <!--                  <label :class="{ hidden: komponenta.servis_interval.length > 0 }" class="label-time p-2" for="komponenta-{{index}}-servis_interval">{{$t('labels.komponenta.servis_interval')}}</label>-->
            <!--                  <input class="input border-0 rounded-4 p-2 fs-5" type="number" id="{{index}}" v-model="komponenta.servis_interval" required />-->
            <!--                  <label :class="{ hidden: komponenta.zadnji_servis.length > 0 }" class="label-time p-2" for="komponenta-{{index}}-zadnji_servis">{{$t('labels.komponenta.zadnji_servis')}}</label>-->
            <!--                  <input class="input border-0 rounded-4 p-2 fs-5" type="number" id="{{index}}" v-model="komponenta.zadnji_servis" required />-->
            <!--                  <label :class="{ hidden: komponenta.naslednji_servis.length > 0 }" class="label-time p-2" for="komponenta-{{index}}-naslednji_servis">{{$t('labels.komponenta.naslednji_servis')}}</label>-->
            <!--                  <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="{{index}}" v-model="komponenta.naslednji_servis" required />-->
            <!--                  <label :class="{ hidden: komponenta.servis_opravljen.length > 0 }" class="label-time p-2" for="komponenta-{{index}}-servis_opravljen">{{$t('labels.komponenta.servis_opravljen')}}</label>-->
            <!--                  <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="{{index}}" v-model="komponenta.servis_opravljen" required />-->
            <!--                </div>-->
            <!--              </TransitionGroup>-->
            <!--            </div>-->
          </ul>
        </div>
        <div v-if="modalPrikaz === 'servis'" class="modal-footer col-12">
          <button class="btn btn-outline-warning" v-if="!this.urejanjeServis"
                  @click.prevent="UrediServis(izbranoLetalo[0].id)">
            <i class="fas fa-user-edit"></i>{{ $t('buttons.servis.uredi') }}
          </button>
          <button class="btn btn-outline-success" v-else @click.prevent="PosodobiZapisServisa()" :disabled="urejam">
            <i class="fas fa-sync-alt"></i> <i class="fas fa-spinner fa-spin" v-if="urejam"></i>
            {{ $t('buttons.servis.posodobi') }}
          </button>&nbsp;
        </div>
        <!-- W&B -->
        <div class="modal-body col-12" v-if="modalPrikaz === 'wb'">
          <!-- PREGLED W&B -->
          <ul class='list-group list-group-flush' v-if="!this.urejanjeWb">
            <li class='list-group-item list-dark'>{{ $t('modal.masa_plovila') }} <span
                class='text-lorange'> {{ izbranoLetalo[0].masa_plovila }} {{ izbranoLetalo[0].enota_mase }}</span></li>
            <li class="list-group-item list-dark"> {{ $t('modal.wb.minCG', {enota: enotaMere === 'kg' ? 'mm' : 'In'}) }}
              <span class="text-lorange"> {{
                  izbranoLetalo[0].cg_limit_min === null ? '/' : izbranoLetalo[0].cg_limit_min
                }} </span></li>
            <li class="list-group-item list-dark"> {{ $t('modal.wb.maxCG', {enota: enotaMere === 'kg' ? 'mm' : 'In'}) }}
              <span class="text-lorange"> {{
                  izbranoLetalo[0].cg_limit_max === null ? '/' : izbranoLetalo[0].cg_limit_max
                }} </span></li>
            <li class="list-group-item list-dark"> {{
                $t('modal.wb.mTeza', {enota: enotaMere === 'kg' ? 'kg' : 'lbs'})
              }} <span class="text-lorange"> {{
                  izbranoLetalo[0].max_masa === null ? '/' : izbranoLetalo[0].max_masa
                }} </span></li>
            <li class="list-group-item list-dark"> {{
                $t('modal.wb.mGorivo', {enota: enotaMere === 'kg' ? 'cm' : 'In'})
              }} <span class="text-lorange"> {{
                  izbranoLetalo[0].arm_gorivo === null ? '/' : izbranoLetalo[0].arm_gorivo
                }} </span></li>
            <li class="list-group-item list-dark"> {{ $t('modal.wb.pTeza', {enota: enotaMere === 'kg' ? 'cm' : 'In'}) }}
              <span class="text-lorange"> {{
                  izbranoLetalo[0].arm_masa === null ? '/' : izbranoLetalo[0].arm_masa
                }} </span></li>
            <li class="list-group-item list-dark"> {{
                $t('modal.wb.tPilot', {enota: enotaMere === 'kg' ? 'cm' : 'In'})
              }} <span class="text-lorange"> {{
                  izbranoLetalo[0].arm_prednji_sedez === null ? '/' : izbranoLetalo[0].arm_prednji_sedez
                }} </span></li>
            <li class="list-group-item list-dark" v-if="izbranoLetalo[0].ima_zadnji_sedez">
              {{ $t('modal.wb.tPotniki', {enota: enotaMere === 'kg' ? 'cm' : 'In'}) }} <span class="text-lorange"> {{
                izbranoLetalo[0].arm_zadnji_sedez === null ? '/' : izbranoLetalo[0].arm_zadnji_sedez
              }} </span></li>
            <li class="list-group-item list-dark">
              {{ $t('modal.wb.tPrtljaga', {enota: enotaMere === 'kg' ? 'cm' : 'In'}) }} <span class="text-lorange"> {{
                izbranoLetalo[0].arm_prtljaga === null ? '/' : izbranoLetalo[0].arm_prtljaga
              }} </span></li>
          </ul>
          <div class="hr-with-text" v-if="!this.urejanjeWb">
            Maks. gorivo in prtljaga
          </div>
          <ul class='list-group list-group-flush' v-if="!this.urejanjeWb">
            <!-- MAX PTRLJAGA IN GORIVO -->
            <li class="list-group-item list-dark">
              {{ $t('modal.wb.maxGorivo', {enota: enotaMere === 'kg' ? 'L' : 'Gal'}) }} <span class="text-lorange"> {{
                izbranoLetalo[0].max_gorivo === null ? '/' : izbranoLetalo[0].max_gorivo
              }} </span></li>
            <li class="list-group-item list-dark">
              {{ $t('modal.wb.maxPrtljaga', {enota: enotaMere === 'kg' ? 'kg' : 'lbs'}) }} <span class="text-lorange"> {{
                izbranoLetalo[0].max_prtljaga === null ? '/' : izbranoLetalo[0].max_prtljaga
              }} </span></li>
          </ul>
          <!-- GRAF OVOJNICA -->
          <div class="hr-with-text" v-if="!this.urejanjeWb">
            Ovojnica grafa
          </div>
          <ul class="list-group list-group-flush" v-if="!this.urejanjeWb">
            <li class="list-group-item list-dark">
              {{ $t('modal.wb.wgt', {stevilka: 1}) }} <span class="text-lorange"> {{
                izbranoLetalo[0].wgt_1 === null ? '/' : izbranoLetalo[0].wgt_1
              }} </span></li>
            <li class="list-group-item list-dark">
              {{ $t('modal.wb.wgt', {stevilka: 2}) }} <span class="text-lorange"> {{
                izbranoLetalo[0].wgt_2 === null ? '/' : izbranoLetalo[0].wgt_2
              }} </span></li>
            <li class="list-group-item list-dark">
              <div class="row">
                <div class="col-6">
                  {{ $t('modal.wb.wgt', {stevilka: "3-x"}) }} <span class="text-lorange"> {{
                    izbranoLetalo[0].wgt_3x === null ? '/' : izbranoLetalo[0].wgt_3x
                  }} </span>
                </div>
                <div class="col-6">
                  {{ $t('modal.wb.wgt', {stevilka: "3-y"}) }} <span class="text-lorange"> {{
                    izbranoLetalo[0].wgt_3y === null ? '/' : izbranoLetalo[0].wgt_3y
                  }} </span>
                </div>
              </div>
            </li>
            <li class="list-group-item list-dark">
              {{ $t('modal.wb.wgt', {stevilka: 4}) }} <span class="text-lorange"> {{
                izbranoLetalo[0].wgt_4 === null ? '/' : izbranoLetalo[0].wgt_4
              }} </span></li>
            <li class="list-group-item list-dark">
              {{ $t('modal.wb.wgt', {stevilka: 5}) }} <span class="text-lorange"> {{
                izbranoLetalo[0].wgt_5 === null ? '/' : izbranoLetalo[0].wgt_5
              }} </span></li>
          </ul>
          <!-- UREJANJE W&B -->
          <ul class='list-group list-group-flush' v-else>
            <li class='list-group-item list-dark'>
              {{ $t('labels.masa_plovila_edit', {enota: enotaMere === 'kg' ? 'kg' : 'lbs'}) }} <span
                class='text-lorange'>{{ izbranoLetalo[0].masa_plovila }}</span>
              <div class="btn-group ms-2" role="group" aria-label="Izbira enote mere">
                <input
                    id="enotaKg"
                    v-model="enotaMere"
                    class="btn-check"
                    type="radio"
                    value="kg"
                >
                <label
                    class="btn btn-outline-light"
                    for="enotaKg"
                >
                  EU
                </label>

                <input
                    id="enotaLbs"
                    v-model="enotaMere"
                    class="btn-check"
                    type="radio"
                    value="lbs"
                >
                <label
                    class="btn btn-outline-light"
                    for="enotaLbs"
                >
                  USA
                </label>

              </div>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="uTip" v-model="uMasa"
                     required/>
            </li>
            <li class='list-group-item list-dark'>{{ $t('modal.wb.minCG', {enota: enotaMere === 'kg' ? 'mm' : 'In'}) }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].cg_limit_min == null ? 'Še ni nastavljen' : izbranoLetalo[0].cg_limit_min
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="cg_limit_min"
                     v-model="cg_limit_min" required/>
            </li>

            <li class='list-group-item list-dark'>{{ $t('modal.wb.maxCG', {enota: enotaMere === 'kg' ? 'mm' : 'In'}) }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].cg_limit_max == null ? 'Še ni nastavljen' : izbranoLetalo[0].cg_limit_max
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="cg_limit_max"
                     v-model="cg_limit_max" required/>
            </li>

            <li class='list-group-item list-dark'>{{ $t('modal.wb.mTeza', {enota: enotaMere === 'kg' ? 'kg' : 'lbs'}) }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].max_masa == null ? 'Še ni nastavljen' : izbranoLetalo[0].max_masa
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="max_masa" v-model="max_masa"
                     required/>
            </li>

            <li class='list-group-item list-dark'>{{
                $t('modal.wb.mGorivo', {enota: enotaMere === 'kg' ? 'cm' : 'In'})
              }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].arm_gorivo == null ? 'Še ni nastavljen' : izbranoLetalo[0].arm_gorivo
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="arm_gorivo"
                     v-model="arm_gorivo" required/>
            </li>

            <li class='list-group-item list-dark'>{{ $t('modal.wb.pTeza', {enota: enotaMere === 'kg' ? 'cm' : 'In'}) }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].arm_masa == null ? 'Še ni nastavljen' : izbranoLetalo[0].arm_masa
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="arm_masa" v-model="arm_masa"
                     required/>
            </li>

            <li class='list-group-item list-dark'>{{ $t('modal.wb.tPilot', {enota: enotaMere === 'kg' ? 'cm' : 'In'}) }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].arm_prednji_sedez == null ? 'Še ni nastavljen' : izbranoLetalo[0].arm_prednji_sedez
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="arm_prednji_sedez"
                     v-model="arm_prednji_sedez" required/>
            </li>
            <!-- ZADNJI SEDEŽ SWITCH -->
            <li class='list-group-item list-dark'>{{ $t('modal.wb.imaZadnji') }} <i class="fas text-orange"
                                                                                    :class="{'fa-times text-danger': !izbranoLetalo[0].ima_zadnji_sedez, 'fa-check text-success': izbranoLetalo[0].ima_zadnji_sedez }"></i>
              <div class="col-12">
                <div class="container">
                  <div class="input border-0 rounded-4 p-2 fs-5">
                    <label class='switch col-6'>
                      <input type='checkbox' v-model="uZadnjiArm" :checked="uZadnjiArm">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </li>
            <li class='list-group-item list-dark' v-if="uZadnjiArm">
              {{ $t('modal.wb.tPotniki', {enota: enotaMere === 'kg' ? 'cm' : 'In'}) }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].arm_zadnji_sedez == null ? 'Še ni nastavljen' : izbranoLetalo[0].arm_zadnji_sedez
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="arm_zadnji_sedez"
                     v-model="arm_zadnji_sedez" required/>
            </li>

            <li class='list-group-item list-dark'>{{
                $t('modal.wb.tPrtljaga', {enota: enotaMere === 'kg' ? 'cm' : 'In'})
              }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].arm_prtljaga == null ? 'Še ni nastavljen' : izbranoLetalo[0].arm_prtljaga
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="arm_prtljaga"
                     v-model="arm_prtljaga" required/>
            </li>

            <!-- MAX TEŽA IN PRTLJAGA -->
            <li class='list-group-item list-dark'>{{
                $t('modal.wb.maxGorivo', {enota: enotaMere === 'kg' ? 'L' : 'Gal'})
              }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].max_gorivo == null ? 'Še ni nastavljen' : izbranoLetalo[0].max_gorivo
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="max_gorivo"
                     v-model="max_gorivo" required/>
            </li>

            <li class='list-group-item list-dark'>
              {{ $t('modal.wb.maxPrtljaga', {enota: enotaMere === 'kg' ? 'kg' : 'lbs'}) }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].max_prtljaga == null ? 'Še ni nastavljen' : izbranoLetalo[0].max_prtljaga
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="max_prtljaga"
                     v-model="max_prtljaga" required/>
            </li>
            <!-- GRAF OVOJNICA -->
            <li class='list-group-item list-dark'>
              {{ $t('modal.wb.wgt', {stevilka: 1}) }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].wgt_1 == null ? 'Še ni nastavljen' : izbranoLetalo[0].wgt_1
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="max_prtljaga"
                     v-model="wgt_1" required/>
            </li>
            <li class='list-group-item list-dark'>
              {{ $t('modal.wb.wgt', {stevilka: 2}) }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].wgt_2 == null ? 'Še ni nastavljen' : izbranoLetalo[0].wgt_2
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="max_prtljaga"
                     v-model="wgt_2" required/>
            </li>
            <li class='list-group-item list-dark'>
              <div class="row">
                <div class="col-6">
                  {{ $t('modal.wb.wgt', {stevilka: "3 - x"}) }}
                  <span class='text-lorange'>{{
                      izbranoLetalo[0].wgt_3x == null ? 'Še ni nastavljen' : izbranoLetalo[0].wgt_3x
                    }}</span>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="max_prtljaga"
                         v-model="wgt_3x" required/>
                </div>
                <div class="col-6">
                  {{ $t('modal.wb.wgt', {stevilka: "3 - y"}) }}
                  <span class='text-lorange'>{{
                      izbranoLetalo[0].wgt_3y == null ? 'Še ni nastavljen' : izbranoLetalo[0].wgt_3y
                    }}</span>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="max_prtljaga"
                         v-model="wgt_3y" required/>
                </div>
              </div>

            </li>
            <li class='list-group-item list-dark'>
              {{ $t('modal.wb.wgt', {stevilka: 4}) }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].wgt_4 == null ? 'Še ni nastavljen' : izbranoLetalo[0].wgt_4
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="max_prtljaga"
                     v-model="wgt_4" required/>
            </li>
            <li class='list-group-item list-dark'>
              {{ $t('modal.wb.wgt', {stevilka: 5}) }}
              <span class='text-lorange'>{{
                  izbranoLetalo[0].wgt_5 == null ? 'Še ni nastavljen' : izbranoLetalo[0].wgt_5
                }}</span>
              <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="max_prtljaga"
                     v-model="wgt_5" required/>
            </li>
          </ul>
        </div>
        <div v-if="modalPrikaz === 'wb'" class="modal-footer col-12">
          <button class="btn btn-outline-warning" v-if="!this.urejanjeWb" @click.prevent="UrediWB(izbranoLetalo[0].id)">
            <i class="fas fa-cog"></i>{{ $t('buttons.wb.uredi') }}
          </button>
          <button class="btn btn-outline-success" v-else @click.prevent="PosodobiZapisWB()" :disabled="urejam">
            <i class="fas fa-sync-alt"></i> <i class="fas fa-spinner fa-spin" v-if="urejam"></i>
            {{ $t('buttons.wb.posodobi') }}
          </button>&nbsp;
        </div>
      </div>
    </div>
  </div>
  <!-- ODMIK OD CAPTCHE -->
  <div class='col-12 p-5'></div>
</template>